import React, { useRef, useState } from 'react';
import { Menu, MenuItem, IconButton } from '@one-thd/sui-atomic-components';
import { More } from '@one-thd/sui-icons';
export var MeatballsMenu = function (_a) {
    var label = _a.label, items = _a.items;
    var menuBtnRef = useRef(null);
    var _b = useState(false), isMenuOpen = _b[0], setIsMenuOpen = _b[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { icon: More, ref: menuBtnRef, onClick: function () {
                setIsMenuOpen(!isMenuOpen);
            }, role: "combobox", "aria-label": "Edit ".concat(label), "aria-expanded": isMenuOpen, "aria-controls": "edit".concat(label, "Menu"), "aria-haspopup": "listbox", "data-testid": "meatballButton" }),
        React.createElement("div", { className: "sui-font-regular sui-text-base sui-leading-tight sui-px-3 sui-whitespace-nowrap" },
            React.createElement(Menu, { id: "edit".concat(label, "Menu"), placement: "bottom-end", open: isMenuOpen, onClose: function () { return setIsMenuOpen(false); }, anchorEl: menuBtnRef.current }, items.map(function (_a) {
                var value = _a.value, isHidden = _a.isHidden, isDisabled = _a.isDisabled, action = _a.action;
                return (!isHidden && (React.createElement(MenuItem, { key: value, value: value, disabled: isDisabled, onClick: function () {
                        setIsMenuOpen(false);
                        action();
                    } }, value)));
            })))));
};
MeatballsMenu.displayName = 'MeatballsMenu';
